export default __webpack_public_path__ + "static/media/uni.77c47e70.jpeg";